import PaypalWBButton from './PaypalButton.component';
export default PaypalWBButton;